/**
 * Authenticated API client for the admin panel. Attaches the JWT (saved by the
 * auth provider under `kcgs_admin_session`) as a Bearer token and unwraps the
 * backend's `{ error: { message } }` shape into thrown Errors.
 */
const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

function token() {
  try {
    return JSON.parse(localStorage.getItem("kcgs_admin_session"))?.token || null;
  } catch {
    return null;
  }
}

async function request(path, { method = "GET", body, isForm } = {}) {
  const headers = {};
  const t = token();
  if (t) headers.Authorization = `Bearer ${t}`;

  let payload = body;
  if (body && !isForm) {
    headers["Content-Type"] = "application/json";
    payload = JSON.stringify(body);
  }

  const res = await fetch(`${API_BASE}${path}`, { method, headers, body: payload });
  if (res.status === 204) return null;

  // Stale/invalid/expired token → clear the session and bounce to login,
  // instead of leaving the panel in a broken "logged in but unauthorized" state.
  if (res.status === 401) {
    localStorage.removeItem("kcgs_admin_session");
    if (window.location.pathname !== "/admin/login") {
      window.location.assign("/admin/login");
    }
  }

  const data = await res.json().catch(() => null);
  if (!res.ok) {
    throw new Error(data?.error?.message || `Request failed (${res.status})`);
  }
  return data;
}

export const adminGet = (path) => request(path);
export const adminPost = (path, body) => request(path, { method: "POST", body });
export const adminPostForm = (path, form) => request(path, { method: "POST", body: form, isForm: true });
export const adminPatch = (path, body) => request(path, { method: "PATCH", body });
export const adminPut = (path, body) => request(path, { method: "PUT", body });
export const adminDelete = (path) => request(path, { method: "DELETE" });
